import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propFunc, propOneOf } from '../../../../../helpers/custom-prop-types';
import RegistrationLink from '../../../../Ui/Registration/RegistrationLink';
const ProfessionalUnitCompanyContactButton = (props) => {
    const { onClick: rawOnClick, showAlertModal, userMode } = props;
    const isGuest = userMode === 'guest';
    const onClick = useMemo(() => {
        switch (userMode) {
            case 'pre':
            case 'other':
                return showAlertModal;
            case 'view':
                return rawOnClick;
            default:
                return undefined;
        }
    }, [rawOnClick, showAlertModal, userMode]);
    return (_jsx("div", Object.assign({ className: 'contact_row' }, { children: _jsx(RegistrationLink, { className: 'button primary outline contact_button', isNoLinkComponent: isGuest ? undefined : 'button', onClick: isGuest ? undefined : onClick, text: '事例・実績について問い合わせる' }) })));
};
ProfessionalUnitCompanyContactButton.propTypes = {
    onClick: propFunc().isRequired,
    showAlertModal: propFunc().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
export default ProfessionalUnitCompanyContactButton;
